import { Feature, FeatureStatus } from '@otto-ec/tracking-bct';
import { DataContainer } from '@otto-ec/tracking-bct/src/lib/datacontainer';

export class FeatureTree {
    private readonly data: Feature;
    private readonly children: FeatureTree[] = [];

    public static createRoot(id: string, name: string, status: FeatureStatus, labels: DataContainer): FeatureTree {
        return new FeatureTree(id, name, status, labels);
    }

    private constructor(
        id: string,
        name: string,
        status: FeatureStatus,
        labels: DataContainer,
        position?: number,
        parentId?: string,
        variationId?: string
    ) {
        this.data = {
            id,
            name,
            status,
            labels,
        };
        if (position) {
            this.data.position = position;
        }
        if (parentId) {
            this.data.parentId = parentId;
        }
        if (variationId) {
            this.data.variationId = variationId;
        }
    }

    public addChild(idPartPrefix: string, name: string, status: FeatureStatus, labels: DataContainer): FeatureTree {
        const childPosition = this.children.length + 1;
        const childId = `${this.data.id}-${idPartPrefix}${childPosition}`;
        const child = new FeatureTree(childId, name, status, labels, this.children.length + 1, this.data.id);
        this.children.push(child);
        return child;
    }

    public toArray(): Feature[] {
        let result: Feature[] = [];
        result.push(this.data);
        this.children.forEach((children) => {
            result = result.concat(children.toArray());
        });
        return result;
    }

    setParentId(parentId: string) {
        this.data.parentId = parentId;
    }

    setPosition(position: number) {
        this.data.position = position;
    }

    setVariationId(variationId: string) {
        this.data.variationId = variationId;
    }
}
